import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-mb-checkbox-field',
  templateUrl: './mb-checkbox-field.component.html',
  styleUrls: ['./mb-checkbox-field.component.scss']
})
export class MbCheckboxFieldComponent implements OnInit {

  @Input() title;
  @Input() wrap: boolean;
  @Input() misfit: boolean;
  @Input() fullWidth: boolean;
  @Input() labelPosition: string;

  constructor() { }

  ngOnInit() {
  }

}
